import mixpanel from "./mixpanel";

const trackPageView = (userInfo, pageName) => {
  // Scroll depth tracking logic
  const getScrollDepth = () => {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollTop = window.scrollY || window.pageYOffset;
    return scrollHeight > 0 ? Math.min((scrollTop / scrollHeight) * 100, 100) : 0; // Percentage scrolled
  };

  // Mixpanel track: Initial page view
  mixpanel.track("Page View", {
    page_name: pageName,
    page_url: window.location.href,
    os: navigator.platform,
    user_type: userInfo
      ? userInfo.isAdmin
        ? "Admin"
        : userInfo.isVideographer
        ? "Videographer"
        : "Generic User"
      : "Unauthenticated User",
    screen_resolution: `${window.screen.width}x${window.screen.height}`,
    scroll_depth: 0, // Start with 0% scroll depth
  });
 
  // Track maximum scroll depth
  let maxScrollDepth = 0;

  const updateScrollDepth = () => {
    maxScrollDepth = Math.max(maxScrollDepth, getScrollDepth());
  };

  const handleBeforeUnload = () => {
    // Track final scroll depth before the user leaves the page
    mixpanel.track("Scroll Depth", { final_scroll_depth: maxScrollDepth });
  };

  // Add event listeners for scroll and beforeunload
  window.addEventListener("scroll", updateScrollDepth);
  window.addEventListener("beforeunload", handleBeforeUnload);

  // Return a cleanup function to remove the event listeners
  return () => {
    window.removeEventListener("scroll", updateScrollDepth);
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
};

export default trackPageView;
